//Constants for status code
export const GLOBAL_STATUS = {
  SUCCESS: 200,
  NO_CONTENT: 204,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
};